import { useState, useEffect } from 'react'
import axios from 'axios'
import API_URL from '../../../config'

export const useLibrarySearch = (userMedia) => {
  const [showSearch, setShowSearch] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [noteResults, setNoteResults] = useState([])
  const [recResults, setRecResults] = useState([])
  const [loadingNotes, setLoadingNotes] = useState(false)
  const [loadingRecs, setLoadingRecs] = useState(false)

  // Search for notes and recommendations when the search query changes
  useEffect(() => {
    const searchNotes = async (query) => {
      if (!query.trim() || query.trim().length < 2) {
        setNoteResults([])
        return
      }

      setLoadingNotes(true)
      try {
        const response = await axios.get(`${API_URL}notes/search/`, {
          params: { query },
        })
        setNoteResults(response.data)
      } catch (error) {
        console.error('Error searching notes:', error)
        setNoteResults([])
      } finally {
        setLoadingNotes(false)
      }
    }

    const searchRecs = async (query) => {
      if (!query.trim() || query.trim().length < 2) {
        setRecResults([])
        return
      }

      setLoadingRecs(true)
      try {
        const response = await axios.get(`${API_URL}recs/search/`, {
          params: { query },
        })
        setRecResults(response.data)
      } catch (error) {
        console.error('Error searching recommendations:', error)
        setRecResults([])
      } finally {
        setLoadingRecs(false)
      }
    }

    // Debounce the search to avoid too many requests
    const timer = setTimeout(() => {
      searchNotes(searchQuery)
      searchRecs(searchQuery)
    }, 500)

    return () => clearTimeout(timer)
  }, [searchQuery])

  const getSearchResults = () => {
    if (!searchQuery.trim()) return null

    const query = searchQuery.toLowerCase().trim()

    const filterItems = (items = [], type) => {
      const filtered = items.filter(
        (item) =>
          (item.title?.toLowerCase().includes(query) ||
            item.primary_artists?.some((artist) => artist.name.toLowerCase().includes(query)) ||
            item.description?.toLowerCase().includes(query)) &&
          (type !== 'albums' || item.direct_add)
      )
      return filtered
    }

    const results = {
      queue: filterItems(userMedia?.queue || [], 'queue'),
      songs: filterItems(userMedia?.collection?.songs || [], 'songs'),
      albums: filterItems(userMedia?.collection?.albums || [], 'albums'),
      playlists: filterItems(userMedia?.collection?.playlists || [], 'playlists'),
      mixes: filterItems(userMedia?.collection?.mixes || [], 'mixes'),
      collages: filterItems(userMedia?.collection?.collages || [], 'collages'),
      notes: noteResults, // Add the note results
      recs: recResults, // Add the recommendation results
    }

    const filteredResults = Object.fromEntries(
      Object.entries(results).filter(([_, items]) => items.length > 0)
    )

    return Object.keys(filteredResults).length > 0 ? filteredResults : {}
  }

  const handleSearch = (query) => {
    setSearchQuery(query)
  }

  return {
    showSearch,
    setShowSearch,
    searchQuery,
    setSearchQuery,
    handleSearch,
    getSearchResults,
    loadingNotes,
    loadingRecs,
  }
}
